import {Cookies} from "../classes/Cookies";

export const initFormNameChangeCity = () => {
	const element = document.querySelector(`form[name="change-city"]`);
	
	if (element)
	{
		const cookieName = `wasOpenedChangeCity`;
		
		if (!Cookies.hasItem(cookieName))
		{
			Cookies.setItem(cookieName, `yes`);
			
			// setTimeout(() => element.querySelector(`button[type="submit"]`).click(), 750);
		}
	}
};
